import { render, staticRenderFns } from "./addAccount.vue?vue&type=template&id=225bb72d&scoped=true&"
import script from "./addAccount.vue?vue&type=script&lang=js&"
export * from "./addAccount.vue?vue&type=script&lang=js&"
import style0 from "./addAccount.vue?vue&type=style&index=0&id=225bb72d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225bb72d",
  null
  
)

export default component.exports